/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';
import GoogleMapItem from './GoogleMapItem';
import Loading from '../../svg/Loading';
import CardGeo from './CardGeo';
import { useDispatch, useSelector } from 'react-redux';
import {
    set_entities_reset_itemone, 
    set_tabnames_reset_one, 
} from '../../../redux/actions/appActions';
import CloseIcon from '../../ui/svgs/CloseIcon';

const TabItem = ({ datas, onDeleteItem, item,
    language, isLoadMax, ip }) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const state = useSelector(state => state.app);
    const { entities, tabNames, hostName } = state;
    let tabNameUpdate = tabNames[ip] ? tabNames[ip] : "mm";

    const deleteHandler = () => {
        onDeleteItem(ip)
        dispatch(set_entities_reset_itemone(ip))
        dispatch(set_tabnames_reset_one(ip))
    }

    return (
        <div className="tabs pt-sm-3 pt-1 mt-1 mt-sm-3">
            <div className="row no-gutters" style={{ justifyContent: "flex-end" }}>
                <button className="btn text-4 line-height-3 mb-0 d-flex align-items-center"
                    onClick={deleteHandler}>
                    <CloseIcon fill="red" width=".7em" />
                    <span className="d-none d-md-block pl-md-2"> {datas.close} </span>
                </button>
            </div>
            {isLoading || isLoadMax ?
                <div className="d-flex align-items-center" style={{ margin: "0 auto" }}>
                    <Loading />
                </div> :
                <div className="card shadow p-3">
                    {/* <div className="border-radius"> */}
                        <div className="row py-2">
                            <div className="col-12 col-lg-7 py-1 h-100">
                                {item[tabNameUpdate] !== null && item[tabNameUpdate] !== undefined &&
                                    <CardGeo
                                        items={item[tabNameUpdate]}
                                        entities={entities[ip]}
                                        hostname={hostName[ip]}
                                    />}
                            </div>
                            <div className="col-12 col-lg-5 py-1">
                                {item && item[tabNameUpdate] !== null && item[tabNameUpdate] !== undefined &&
                                    <GoogleMapItem
                                        language={language}
                                        idGoogle={ip.toString()}
                                        lat={item[tabNameUpdate][4] !== undefined ? item[tabNameUpdate][4].value : 32}
                                        lng={item[tabNameUpdate][5] !== undefined ? item[tabNameUpdate][5].value : 32}
                                    />}
                            </div>
                        </div>
                    {/* </div> */}
                </div>}
        </div>
    )
}

export default TabItem;